import { useQuery } from "react-query";
import { reactQueryGet } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";
import type { HelpWidgetConversation } from "../types/help_widget_conversation";

export const useShowConversation = (id: string) => {
  const fetchConversation = () =>
    reactQueryGet<HelpWidgetConversation>(
      internalApi.supportWidget.showConversationV2({ id }),
    );

  return useQuery(["conversation_v2", id], fetchConversation, {
    enabled: Boolean(id),
  });
};
